import React from 'react'

function ArrowRightIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M10 17l5-5-5-5v10z" /></svg>
    )
}

export default ArrowRightIcon